import { Button } from "@egaranti/components";
import { Tag } from "@egaranti/components";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@egaranti/components";
import { TableSkeleton } from "@egaranti/components";
import { useToast } from "@egaranti/components";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import SubMerchantService from "@/services/subMerchantService";

import EmptyTable from "@/components/shared/EmptyTable";

import { ExternalLink } from "lucide-react";

import { openSubMerchantPanel } from "@/lib/subMerchantSession";

const SubMerchants = () => {
  const { t } = useTranslation();
  const { toast } = useToast();

  const [subMerchants, setSubMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openingId, setOpeningId] = useState(null);

  useEffect(() => {
    SubMerchantService.getSubMerchants()
      .then(setSubMerchants)
      .finally(() => setLoading(false));
  }, []);

  const openPanel = (subMerchant) => {
    setOpeningId(subMerchant.id);

    openSubMerchantPanel(async () => {
      const { jwtToken } = await SubMerchantService.getSubMerchantToken(
        subMerchant.id,
      );
      return jwtToken;
    })
      .catch((err) => {
        toast({
          variant: "error",
          description:
            err.response?.data?.errors?.[0]?.message ||
            t("subMerchantsPage.openFailed", "Alt bayi paneli açılamadı."),
        });
      })
      .finally(() => setOpeningId(null));
  };

  return (
    <main className="min-h-full bg-[#F9FAFC] p-4">
      <div className="rounded-lg">
        <div className="flex flex-col rounded-t-lg bg-white pb-4">
          {loading ? (
            <Table>
              <TableSkeleton colSpan={6} />
            </Table>
          ) : subMerchants.length ? (
            <Table>
              <TableHeader>
                <TableHead>{t("subMerchantsPage.title", "Alt Bayi")}</TableHead>
                <TableHead>{t("settingsPage.fullName")}</TableHead>
                <TableHead>{t("settingsPage.phone")}</TableHead>
                <TableHead>{t("settingsPage.email")}</TableHead>
                <TableHead>{t("settingsPage.status")}</TableHead>
                <TableHead></TableHead>
              </TableHeader>
              <TableBody>
                {subMerchants.map((subMerchant) => (
                  <TableRow key={subMerchant.id}>
                    <TableCell>{subMerchant.title}</TableCell>
                    <TableCell>
                      {[subMerchant.adminFirstName, subMerchant.adminLastName]
                        .filter(Boolean)
                        .join(" ") || "-"}
                    </TableCell>
                    <TableCell>{subMerchant.adminPhone || "-"}</TableCell>
                    <TableCell>{subMerchant.adminEmail || "-"}</TableCell>
                    <TableCell>
                      <Tag
                        size="sm"
                        variant={
                          subMerchant.status === "ACTIVE" ? "blue" : "yellow"
                        }
                      >
                        {subMerchant.status === "ACTIVE"
                          ? t("settingsPage.active")
                          : t("subMerchantsPage.pending", "Bekleniyor")}
                      </Tag>
                    </TableCell>
                    <TableCell className="text-right">
                      <Button
                        size="sm"
                        disabled={
                          subMerchant.status !== "ACTIVE" ||
                          openingId === subMerchant.id
                        }
                        onClick={() => openPanel(subMerchant)}
                      >
                        <ExternalLink size={16} />
                        <span className="ml-2">
                          {t("subMerchantsPage.openPanel", "Panele Git")}
                        </span>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <EmptyTable
              title={t("subMerchantsPage.emptyTitle", "Alt bayi bulunamadı")}
              desc={t(
                "subMerchantsPage.emptyDesc",
                "Hesabınıza bağlı bir alt bayi bulunmuyor.",
              )}
            />
          )}
        </div>
      </div>
    </main>
  );
};

export default SubMerchants;
